import { moveItemInArray } from '@angular/cdk/drag-drop';
import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import { UserSubmitted } from '../actions/edit-flow.actions';
import {
  AddFlow,
  ContextFlowChanged,
  DeleteFlow,
  DisableRowDrag,
  EnableRowDrag,
  FlowEndDateChanged,
  FlowEventChanged,
  FlowStartDateChanged,
  FlowStatusChanged,
  GetContextFlowSuccess,
  GetFlowEventsSuccess,
  GetFlowEventSuccess,
  GetFlowTableSuccess,
  InitFlowTableColumns,
  ReorderFlowTable,
} from '../actions/flow-configuration.actions';
import { FlowConfigurationState } from '../models/flows.model';

const initialState: FlowConfigurationState = {
  contextFlowValues: [],
  contextFlow: '',
  flowEventValues: [],
  flowEvent: '',
  displayedColumns: {},
  flowTable: [],
  dragEnabled: false,
  addFlow: [],
  userSubmitted: false,
};

export const FlowConfigurationReducer = createReducer(
  initialState,
  on(InitFlowTableColumns, (state, { displayedColumns }) => ({
    ...state,
    displayedColumns,
  })),
  on(UserSubmitted, (state) => ({
    ...state,
    userSubmitted: true,
  })),
  on(GetFlowEventsSuccess, (state, { res }) => ({
    ...state,
    contextFlowValues: res.payload.data,
  })),
  on(ContextFlowChanged, (state, { contextFlow }) => ({
    ...state,
    contextFlow,
    flowEvent: '',
    flowEventValues: contextFlow ? [] : state.flowEventValues,
  })),
  on(GetContextFlowSuccess, (state, { res }) => ({
    ...state,
    flowEventValues: res.payload.data,
  })),
  on(FlowEventChanged, (state, { flowEvent }) => ({
    ...state,
    flowEvent,
  })),
  on(GetFlowEventSuccess, (state, { res }) => ({
    ...state,
    addFlow: res,
  })),
  on(GetFlowTableSuccess, (state, { res }) => ({
    ...state,
    flowTable: res?.payload?.data.map((flow, newIndex) => ({
      ...flow,
      executionOrder: newIndex,
    })),
  })),
  on(FlowStatusChanged, (state, { index }) => {
    let flowTable: any = [...state.flowTable];
    flowTable[index] = {
      ...flowTable[index],
      deleteFlag: flowTable[index].deleteFlag === false ? true : false,
    };
    return {
      ...state,
      flowTable,
    };
  }),
  on(FlowStartDateChanged, (state, { activeFrom, index }) => {
    let flowTable: any = [...state.flowTable];
    flowTable[index] = { ...flowTable[index], activeFrom };
    return {
      ...state,
      flowTable,
    };
  }),
  on(FlowEndDateChanged, (state, { activeUntil, index }) => {
    let flowTable: any = [...state.flowTable];
    flowTable[index] = { ...flowTable[index], activeUntil };
    return {
      ...state,
      flowTable,
    };
  }),
  on(DeleteFlow, (state, { index }) => ({
    ...state,
    flowTable: state.flowTable
      .filter((_, tableIndex) => tableIndex !== index)
      .map((flow, newIndex) => ({
        ...flow,
        executionOrder: newIndex,
      })),
  })),
  on(EnableRowDrag, (state) => ({
    ...state,
    dragEnabled: true,
  })),
  on(DisableRowDrag, (state) => ({
    ...state,
    dragEnabled: false,
  })),
  on(ReorderFlowTable, (state, { previousIndex, currentIndex }) => {
    let flowTable = [...state.flowTable];
    moveItemInArray(flowTable, previousIndex, currentIndex);
    flowTable = flowTable.map((flow, index) => ({
      ...flow,
      executionOrder: index,
    }));

    return {
      ...state,
      flowTable,
    };
  }),
  on(AddFlow, (state, { flowID, currDate }) => ({
    ...state,
    flowTable: [
      ...state.flowTable,
      {
        flowID,
        executionOrder: state.flowTable.length,
        deleteFlag: false,
        activeFrom: currDate,
        activeUntil: currDate,
      },
    ].map((flow, newIndex) => ({
      ...flow,
      executionOrder: newIndex,
    })),
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    contextFlow: '',
    flowEvent: '',
    flowTable: [],
    addFlow: [],
    userSubmitted: false,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
